<div class="error-page-container">
  <div class="error-content">
    <!-- Error Image -->
    <div class="error-image-container">
      <img
        src="../../../../assets/images/error404combined.png"
        alt="404 Error Illustration"
        class="error-image"
      />
    </div>

    <!-- Error Text Content -->
    <div class="error-text-container">
      <h1 class="error-title">{{ staticTextService.text.error['404'] }}</h1>

      <p class="error-subtitle">
        {{ staticTextService.text.error['errorText'][0] }}
      </p>

      <div class="error-description">
        <p class="error-message">
          {{ staticTextService.text.error['errorText'][1] }} <br />
          {{ staticTextService.text.error['errorText'][2] }}<br />
          {{ staticTextService.text.error['errorText'][3] }}
          <a href="mailto:gemfin@Geminisolutions.com" class="error-link">
            {{ staticTextService.text.error['errorText'][4] }}
          </a>
        </p>
      </div>

      <!-- Action Button -->
      <div class="error-actions">
        <button
          pButton
          (onClick)="returnToHome()"
          label="{{ staticTextService.text.error['back'] }}"
          icon="pi pi-home"
          severity="primary"
          class="add-btn"
          (click)="returnToHome()"
        ></button>
      </div>
    </div>
  </div>
</div>
